import React, { memo, } from 'react';
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
   
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
 

import Statusform from '../../Statusform';
import UserRole from '../../UserRole';
import EscalationSettings from '../Escalation/EscalationSettings';

type StatusItem = {
  _id: string;
  name: string;
  uid: string;
};

type NotificationPayload = {
  conditions: string[];
  users: string[];
  roles: string[];
  channels: string[];
};

 

interface CommonFormFieldsProps {
  selectedNode: any;
  onStatusesLoaded?: (list: StatusItem[]) => void;
  onNotificationChange?: (payload: NotificationPayload) => void;
  // onNodeInstructionChange?: (payload: NodeInstructionPayload) => void;
  notificationInitialValues?: {
    scheduleOnETA?: boolean;
    onCompletion?: boolean;
    notifyRoles?: string[];
    notifyUsers?: string[];
    notificationChannel?: string[];
  };
  escalationPayload?: any;
  onEscalationChange?: (payload: any) => void;
}

const CommonFormFields: React.FC<CommonFormFieldsProps> = ({
  selectedNode,
  onStatusesLoaded,
  onNotificationChange,
  notificationInitialValues,
  escalationPayload,
  onEscalationChange
}) => { 

  // Derive client UID just like EscalationSettings
  const clientObject = selectedNode?.data?.client || selectedNode?.data?.step?.client;
  const clientUid = clientObject?.uid || clientObject;

  return (
    <>
      <Accordion sx={{ }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography variant="subtitle1" fontWeight={600}>
            Common Settings
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            <UserRole name="actor" clientUid={clientUid} />
            <Statusform
              selectedNode={selectedNode}
              name="onCompleteStatusUid"
              onStatusesLoaded={onStatusesLoaded}
            />
            <EscalationSettings
              selectedNode={selectedNode}
              escalationPayload={escalationPayload}
              onEscalationChange={onEscalationChange}
            /> 
          
          </Box>
        </AccordionDetails>
      </Accordion> 
    </>
  );
};

export default memo(CommonFormFields);
